var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('div',{staticClass:"b-highlight"},[_c('highlight-text',{class:_vm.data.size,attrs:{"tag":_vm.data.markup,"text":_vm.data.text,"highlight-bg":_vm.highlightBg || 'yellow-light'}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }